import _ from 'underscore';

function parentIdSelector(variables) {
  return variables.locator.descriptor.campaign_id;
}

export function sideEffectFn(response, request, spec, {
  tryMergeItemsToCacheStore,
}) {
  const { Ads, Targets, Keywords } = response;

  if (!_.isEmpty(Ads)) {
    tryMergeItemsToCacheStore({
      items: Ads,
      schemaName: 'ad',
      itemKeySelector: ad => ad.Id,
      parentSchameName: 'campaign',
      parentId: parentIdSelector(request.variables),
    });
  }
  if (!_.isEmpty(Targets)) {
    tryMergeItemsToCacheStore({
      items: Targets,
      schemaName: 'target',
      itemKeySelector: target => target.Id,
      parentSchameName: 'campaign',
      parentId: parentIdSelector(request.variables),
    });
  }
  if (!_.isEmpty(Keywords)) {
    tryMergeItemsToCacheStore({
      items: Keywords,
      schemaName: 'keyword',
      itemKeySelector: keyword => keyword.Id,
      parentSchameName: 'campaign',
      parentId: parentIdSelector(request.variables),
    });
  }
}
